import {
  fevorvertragsnummer,
  generateMigrateRisikoschluessel,
  loadAndMigrateState,
  Migrator,
  migrateProduktForVorteilsrabatt,
  migrateProduktnameToEnum,
  migrateZahlungsoptionen,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { transformGefahrenTHH } from './3_migrate_risikoschluessel';
import { migrateAssekuranztarif } from './4_migrate_assekuranztarif';
import { migrateSelbstbeteiligung } from './5_migrate_selbstbeteiligung';
import { migrateRassen } from './8_migrate_rasse';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 2,
    migratorFunction: fevorvertragsnummer,
  },
  {
    toVersion: 3,
    migratorFunction: generateMigrateRisikoschluessel(transformGefahrenTHH),
  },
  {
    toVersion: 4,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 5,
    migratorFunction: migrateSelbstbeteiligung,
  },
  {
    toVersion: 6,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 7,
    migratorFunction: migrateProduktnameToEnum,
  },
  {
    toVersion: 8,
    migratorFunction: migrateRassen,
  },
  {
    toVersion: 9,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 10,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 11,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
];

export const loadAndMigrateThhHundState = (
  currentState: IAppState,
  loadedState: { version: number },
  beibehalten?: boolean,
) => loadAndMigrateState(currentState, loadedState, stateMigrators, beibehalten);
